import React, { useEffect, useState, useContext } from 'react';
import { Pie } from '@ant-design/plots';
import _ from 'lodash';
import {
    Col,
    Divider,
    Layout,
    Row,
    Spin,
    Table,
    message,
    Typography,
    Collapse,
    Tooltip,
    Select,
} from 'antd';
import api from 'api';
import { get, post } from 'utils/fetch';
import { NameItem } from 'types/investor';
import OfferingTile from './OfferingTile';
import { useLocation } from 'react-router-dom';
import { OfferingDetailed } from './OfferingDetailed';
import { AppHeader } from 'components/AppHeader';
import { CompanyInfo } from 'components/CompanyInfo';
import { isPhoneSize } from 'utils/util';
import { GlobalContext } from 'GlobalContext';
import { getTypeBackgroundColor } from 'utils/util';
import { OfferingFilters } from './OfferingFilters';
import { OfferingTileV2 } from './OfferingTileV2';

const { Text } = Typography;

interface OfferingProps {
    email: string | undefined;
    basicInfo: any;
    setEmail: any;
    setBasicInfo: any;
}

const Offerings: React.FC<OfferingProps> = ({
    email,
    basicInfo,
    setBasicInfo,
    setEmail,
}) => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');
    //console.log("Offering id:", id)

    const [messageApi, contextHolder] = message.useMessage();
    const { investorIdToView, accessToken, refreshSession, offeringFilter } =
        useContext(GlobalContext);
    const [loading, setLoading] = useState<boolean>(true);
    const [funds, setFunds] = useState<any[]>([]);
    const [nameidMapping, setNameIDMapping] = useState<
        Record<string, NameItem>
    >({});
    const [fundTypeToView, setFundTypeToView] = useState<string>('Both');
    const displayErrorMessage = (message: string) => {
        messageApi.open({
            type: 'error',
            content: message,
        });
    };

    async function fetchFunds(id: number) {
        await get(
            api.fund.uninvestedListId(id),
            setFunds,
            (errors: any[]) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchNameIDMapping(nameidList: string[]) {
        await post(
            api.misc.getNameIDMapping,
            {
                payload: nameidList,
            },
            (data) => {
                if (data.length !== nameidList.length) return;
                const updateObj: Record<string, NameItem> = {};
                nameidList.forEach((e, i) => {
                    updateObj[e] = data[i];
                });
                setNameIDMapping({
                    ...nameidMapping,
                    ...updateObj,
                });
            },
            (errors: any[]) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
        setLoading(false);
    }

    async function fetchData(id: number) {
        setLoading(true);
        await fetchFunds(id);
        //console.log(funds)
        setLoading(false);
    }

    useEffect(() => {
        if (accessToken === '') return;
        fetchData(investorIdToView);
    }, [accessToken]);
    let content = null;
    if (id !== null)
        return (
            <>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            flexShrink: 1,
                        }}
                    >
                        <OfferingDetailed id={id} isHolding={false} />
                    </div>
                    {!isPhoneSize() && (
                        <div style={{ width: '260px', flexShrink: '0' }}>
                            <CompanyInfo action={'Invest'} />
                        </div>
                    )}
                </div>
            </>
        );
    if (loading)
        content = <Spin style={{ height: '100vh', marginTop: '30px' }} />;
    else {
        content = (
            <div
                style={
                    isPhoneSize()
                        ? {}
                        : {
                              overflowY: 'scroll',
                              overflowX: 'hidden',
                              scrollbarWidth: 'none',
                              height: 'calc(100vh - 60px)',
                              width: '100%',
                          }
                }
            >
                <Layout style={{ background: 'transparent' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h1 style={{ width: '100%', paddingTop: '5px' }}>
                            Offerings
                        </h1>

                        {/* <h2>Debt Offerings</h2> */}
                        {/* <div
                            style={{
                                whiteSpace: 'nowrap',
                                marginRight: '10px',
                            }}
                        >
                            Filter Fund Type
                        </div>
                        <Select
                            onChange={(e) => setFundTypeToView(e)}
                            // placeholder="Filter Fund Type"
                            defaultValue={'Both'}
                            style={{ width: '200px' }}
                            optionFilterProp="children"
                            options={[
                                {
                                    value: 'Both',
                                    label: 'Both',
                                },
                                {
                                    value: 'Debt',
                                    label: 'Debt',
                                },
                                {
                                    value: 'Equity',
                                    label: 'Equity',
                                },
                            ]}
                        ></Select> */}
                    </div>
                    <OfferingFilters />
                    <Row
                        gutter={[24, 24]}
                        style={
                            isPhoneSize() ? { justifyContent: 'center' } : {}
                        }
                    >
                        {funds &&
                            funds
                                // .filter((fund) => {
                                //     if (fundTypeToView === 'Both') {
                                //         return true;
                                //     } else {
                                //         return fund.type
                                //             .toLowerCase()
                                //             .includes(
                                //                 fundTypeToView.toLowerCase()
                                //             );
                                //     }
                                // })
                                .filter((fund) => {
                                    if (!fund.offering_status) {
                                        return true;
                                    }
                                    return offeringFilter[
                                        'Investment Status'
                                    ].includes(fund.offering_status);
                                })
                                .filter((fund) => {
                                    if (!fund.type) {
                                        return true;
                                    }
                                    return fund.type
                                        .split('/')
                                        .some((type: string) =>
                                            offeringFilter[
                                                'Investment Type'
                                            ].includes(type.trim())
                                        );
                                })
                                .filter((fund) => {
                                    if (!fund.min_investment) {
                                        return true;
                                    }
                                    return (
                                        fund.min_investment >=
                                            offeringFilter[
                                                'Minimum Investment'
                                            ][0] /
                                                1000 &&
                                        fund.min_investment <=
                                            offeringFilter[
                                                'Minimum Investment'
                                            ][1] /
                                                1000
                                    );
                                })
                                .filter((fund) => {
                                    const term = fund.target_term;
                                    const filter = offeringFilter['Term'];

                                    if (!term) return true;

                                    if (
                                        term <= 6 &&
                                        filter.includes('0-6 Months')
                                    )
                                        return true;
                                    if (
                                        term >= 6 &&
                                        term <= 24 &&
                                        filter.includes('6-24 Months')
                                    )
                                        return true;
                                    if (
                                        term >= 24 &&
                                        filter.includes('24 Months+')
                                    )
                                        return true;

                                    return false;
                                })
                                /*.sort((a, b) => {
                                    if (a.name < b.name) return -1;
                                    return 1;
                                })*/
                                .sort((a, b) => {
                                    // Open 最前
                                    if (a.offering_status === 'Open' && b.offering_status !== 'Open') {
                                        return -1;
                                    }

                                    if (a.offering_status !== 'Open' && b.offering_status === 'Open') {
                                        return 1;
                                    }

                                    // Closed 最后
                                    if (a.offering_status === 'Closed' && b.offering_status !== 'Closed') {
                                        return 1;
                                    }

                                    if (a.offering_status !== 'Closed' && b.offering_status === 'Closed') {
                                        return -1;
                                    }

                                    // 其它按 name 排序
                                    return a.name.localeCompare(b.name);
                                })
                                .map((f, id) => (
                                    <Col key={id}>
                                        {/* <OfferingTile
                                            openStatus={f.is_open}
                                            title={f.name}
                                            type={f.type}
                                            description={f.description}
                                            link={`/offerings?id=${f.id}`}
                                            imgSrc={
                                                f.img_src
                                                    ? f.img_src
                                                    : 'https://static.wixstatic.com/media/1e11ac_c9300dd8e54c4e5397141c2246af71c6~mv2.png/v1/fill/w_948,h_1226,al_t,q_90,usm_0.66_1.00_0.01,enc_auto/1e11ac_c9300dd8e54c4e5397141c2246af71c6~mv2.png'
                                            }
                                        /> */}
                                        <OfferingTileV2
                                            fund={f}
                                            link={`/offerings?id=${f.id}`}
                                        />
                                    </Col>
                                ))}
                    </Row>
                </Layout>
                <div
                    style={{ height: '50px', width: '100%', display: 'flex' }}
                ></div>
            </div>
        );
    }
    return (
        <div
            style={
                isPhoneSize()
                    ? {
                          display: 'flex',
                          flexDirection: 'column',
                          // overflowX: "hidden",
                          scrollbarWidth: 'none',
                          height: 'calc(100vh - 154px)',
                          paddingBottom: '50px',
                      }
                    : {
                          display: 'flex',
                          flexDirection: 'row',
                      }
            }
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    // width: '100%',
                    flex: 1,
                    minWidth: '100px',
                }}
            >
                {!isPhoneSize() && (
                    <AppHeader
                        setBasicInfo={setBasicInfo}
                        basicInfo={basicInfo}
                        setEmail={setEmail}
                    />
                )}
                {id === null ? (
                    <>
                        {contextHolder}
                        {content}
                    </>
                ) : (
                    <></>
                )}
            </div>
            <div
                style={
                    isPhoneSize()
                        ? {
                              width: '380px',
                              textAlign: 'left',
                              background: 'transparent',
                              padding: 12,
                          }
                        : {
                              width: '280px',
                              textAlign: 'left',
                              background: 'transparent',
                              padding: 12,
                              overflowY: 'scroll',
                              overflowX: 'hidden',
                              height: '100vh',
                              scrollbarWidth: 'none',
                              // height: 'calc(100vh - 144px)'
                          }
                }
            >
                <Row gutter={[12, 16]}></Row>

                <CompanyInfo />
            </div>
        </div>
    );
};

export default Offerings;
